/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

function HouseIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="42" height="42" rx="21" />
      <path
        d="M11.5508 22.05L17.6333 28.1326C18.0434 28.5426 18.7082 28.5426 19.1182 28.1326L32.5508 14.7"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default memo(HouseIcon);
